import { apiSlice } from "../../app/api/apiSlice";

export const galleryEventsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    // =========================
    // GET ALL EVENTS
    // =========================
    getGalleryEvents: builder.query({
      query: () => "/api/v1/admin/gallery/events",

      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map((event) => ({
                type: "GalleryEvent",
                id: event._id,
              })),
              { type: "GalleryEvent", id: "LIST" },
            ]
          : [{ type: "GalleryEvent", id: "LIST" }],

      keepUnusedDataFor: 300,
    }),

    // =========================
    // GET SINGLE EVENT
    // =========================
    getGalleryEvent: builder.query({
      query: (id) => `/api/v1/admin/gallery/events/${id}`,

      providesTags: (result, error, id) => [
        { type: "GalleryEvent", id },
      ],
    }),

    // =========================
    // CREATE EVENT
    // =========================
    createGalleryEvent: builder.mutation({
      query: (data) => ({
        url: "/api/v1/admin/gallery/events",
        method: "POST",
        body: data,
      }),

      invalidatesTags: [{ type: "GalleryEvent", id: "LIST" }],
    }),

    // =========================
    // UPDATE EVENT
    // =========================
    updateGalleryEvent: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/api/v1/admin/gallery/events/${id}`,
        method: "PUT",
        body: data,
      }),

      invalidatesTags: (result, error, arg) => [
        { type: "GalleryEvent", id: arg.id },
        { type: "GalleryEvent", id: "LIST" },
      ],
    }),

    // =========================
    // DELETE EVENT
    // =========================
    deleteGalleryEvent: builder.mutation({
      query: (id) => ({
        url: `/api/v1/admin/gallery/events/${id}`,
        method: "DELETE",
      }),

      invalidatesTags: [{ type: "GalleryEvent", id: "LIST" }],
    }),

  }),
});

export const {
  useGetGalleryEventsQuery,
  useGetGalleryEventQuery,
  useCreateGalleryEventMutation,
  useUpdateGalleryEventMutation,
  useDeleteGalleryEventMutation,
} = galleryEventsApiSlice;
